import { FC } from "react";
import { useTheme } from "@mui/material/styles";
import Link from "next/link";

interface IActionLinkProps {
  href: string;
  rounded?: boolean;
}

interface IAnchorStyles {
  [key: string]: number | string;
}

export const ActionLink: FC<IActionLinkProps> = (props) => {
  const { href, rounded } = props;
  const theme = useTheme();
  const anchorStyles: IAnchorStyles = {
    background: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.secondary.main}`,
    color: theme.palette.common.white,
    display: "inline-block",
    fill: theme.palette.common.white,
    fontFamily: '"Oswald", "Arial Narrow", sans-serif',
    fontSize: "0.75rem",
    fontWeight: 700,
    lineHeight: 1.2,
    minWidth: "12em",
    padding: "1em 1.25em",
    textAlign: "center",
    textDecoration: "none",
    textTransform: "uppercase",
    transition: "background-color 200ms, border-color 200ms",
    position: "relative",
  };

  if (rounded) {
    anchorStyles.borderRadius = "2rem";
  }
  return (
    <Link href={href}>
      <a className="action action--primary">{props.children}</a>
    </Link>
  );
};

ActionLink.defaultProps = {
  rounded: false,
};
